import React from "react";
import { Input, InputProps } from "antd";

import classes from "./InputNumberLot.module.css";

export const InputNumberLot: React.FC<InputProps> = (props) => {
  const handleInput: React.FormEventHandler<HTMLInputElement> = (e) => {
    const inputElement = e.currentTarget;

    inputElement.value = inputElement.value
      .replace(/\D/g, "") // Удаляем любые символы, кроме цифр,
      .replace(/^0+/, "") // убираем лидирующие нули
      .slice(0, 3); // и ограничиваем длину до 3 символов

    if (props.onChange) {
      props.onChange({
        ...e,
        target: { ...inputElement, value: inputElement.value },
      });
    }
  };

  return (
    <Input
      className={classes.inputNumber}
      {...props}
      type="number"
      onInput={handleInput} // Используем onInput для фильтрации
    />
  );
};
